import React, { Component } from 'react';
import { Link, Route } from 'react-router-dom';
import {
    Search, DataTable, Loading, DataTableSkeleton,
    TableContainer, Pagination, Form, FormLabel, TextInput, ComposedModal, ModalHeader, ModalBody, FormGroup, TableHead, Table, DropdownSkeleton, TableSelectRow, DatePickerSkeleton, TableBatchActions, TableBatchAction, TableBody, TableRow, TableCell, TableHeader, TableToolbar, TableToolbarContent, Button,
} from 'carbon-components-react';
import Edit16 from '@carbon/icons-react/lib/edit/16';
import Delete16 from '@carbon/icons-react/lib/delete/16';
import Send16 from '@carbon/icons-react/lib/send/16';
import { CheckmarkOutline16, CheckmarkFilled20, Add20, Error16, Download16, Document16, Tag } from '@carbon/icons-react/lib/';
import { RenderDataTableCell, NoRecordsPlaceholder } from '../../helpers/jsonschemaform/DataTableExtention';
import { showNotification } from '../../helpers/notification/BaseNotification';
import { getSuccess, getError, entitiesLabels, apioperation, DateFormat, LogOperation, LogModule } from '../../helpers/Constants';
import moment, { invalid } from 'moment';
import { activityLog, me, api, } from '../../helpers/api/api';
import { ComboBox } from '../../helpers/ComboBox';
import { CanExecuteAction, IsInRole } from '../../helpers/authorization/Policies';
import { AppContext } from '../../helpers/context/AppContext';
import PageBreadCrumb from '../../helpers/PageBreadCrumb';
import DateTimePicker from '../../helpers/DateTimePicker';
import { switchDateFormat } from '../../helpers/jsonschemaform/customwidget/utils';
import Data16 from '@carbon/icons-react/lib/data--1/16';
import { StatusTag } from '../../helpers/PageBreadCrumb';
import SimpleReactValidator from 'simple-react-validator';
import { Online } from '../common/OnLineOffLine';
const baseUrl = '/activityLog/';
const searchProp = {
    module: '',
    operation: '',
    entity: '',
    referenceEntity: '',
    property: '',
    value: '',
    user: '',
    occurredAtFrom: null,
    occurredAtTo: null,


};
export class ActivityLog extends Component {
    constructor(props) {
        super(props);
        this.validator = new SimpleReactValidator();

        this.state = {
            currentPage: 1,
            pageSize: 10,
            rowCount: 0,
            isLoading: true,
            isLoadingList: true,
            isLoadingEntity: true,
            itemList: [],
            currentPage: 1,
            pageSize: 10,
            rowCount: 0,
            searchModel: {
                ...searchProp
            },
            entityList: [],
            xmodule: [],
            xentity: [],
            xoperation: [LogOperation.OPERATION_LOG_UPDATE, LogOperation.OPERATION_LOG_DELETE, LogOperation.OPERATION_LOG_INSERT],
            isOpenDetailsModal: false,
            DetailModalId: null,


        };
        this.toggleSearchForm = this.toggleSearchForm.bind(this);
        this.updateState = this.updateState.bind(this);
        this.handleClickCancelSearch = this.handleClickCancelSearch.bind(this);
        this.getEntityFiltered = this.getEntityFiltered.bind(this);
        this.renderSearchform = this.renderSearchform.bind(this);
        this.getActivityLog = this.getActivityLog.bind(this);
        this.DetailsForm = this.DetailsForm.bind(this);
        this.closeDetailsForm = this.closeDetailsForm.bind(this);
    }

    componentDidMount() {
        this.getActivityLog();
        this.getEntityActivityLog();
    }

    /*************API get********************/
    //API GET COMBO ENTITY 
    getEntityActivityLog() {
        this.setState({ isLoadingEntity: true });
        activityLog.getEntity()
            .then(response => {

                var data = response.data;
                var module = data.map(x => x.module);
                module = module.filter((x, idx) => module.indexOf(x) === idx)
                //var entity = data.map(x => x.entity );
                this.setState({
                    entityList: data,
                    xmodule: module,
                    xentity: data
                });

            }).catch(error => {
                showNotification.error(`${entitiesLabels.ERROR}`,getError(error, entitiesLabels.ACTIVITYLOG, apioperation.GET));
            }).finally(() => {
                this.setState({ isLoadingEntity: false });
            });
    }
    //API GET FILTERED
    getActivityLog(param) {

        if (this.validator.allValid()) {
            this.setState({
                isLoading: true,
            })

            var idX = null;
            if (this.state.entityList && this.state.searchModel.referenceEntity) {
                var obb = this.state.entityList.find(x => x.referenceEntity == this.state.searchModel.referenceEntity);
                if (obb) {
                    idX = obb.id;
                }
            }

            const data = {
                params: {
                    page: (param && param.page) ? param.page : this.state.currentPage,
                    pageSize: (param && param.pageSize) ? param.pageSize : this.state.pageSize,
                    id: idX,
                    ...this.state.searchModel
                }
            };
            activityLog.getWithParam(data)
                .then(response => {
                    this.setState({
                        ...response.data
                    });

                }).catch(error => {
                    showNotification.error(`${entitiesLabels.ERROR}`,getError(error, entitiesLabels.ACTIVITYLOG, apioperation.GET));
                }).finally(() => {
                    this.setState({
                        isLoading: false,
                    });
                });
        } else {
            this.validator.showMessages();
            showNotification.warning(`${entitiesLabels.WARNING}`,"Date required fields are missing  ");
            this.forceUpdate();
        }
    }
    //API GET COMBO ENTITY FILTERED FOR MODULE
    getEntityFiltered() {
        this.setState({ isLoadingEntity: true });
        var module = this.state.searchModel.module;
        const data = {
            params: {
                module: this.state.searchModel.module
            }
        };
        activityLog.getfilteredEntity(data)
            .then(response => {
                var data = response.data;


                this.setState({
                    xentity: data
                });

            }).catch(error => {
                showNotification.error(getError(error, entitiesLabels.ACTIVITYLOG, apioperation.GET));
            }).finally(() => {
                this.setState({
                    isLoading: false,
                    isLoadingEntity: false
                });
            });
    }

    //METODI VARI

    updateState = (inputName, inputValue, objName) => {
        let statusCopy = Object.assign({}, this.state);
        statusCopy[objName][inputName] = inputValue;
        this.setState(statusCopy);
    }

    handleChangeComboEntity = (inputName, selectedItem, objName) => {

        let inputValue = selectedItem ? selectedItem.tableDisplayName : null;
        let statusCopy = Object.assign({}, this.state);
        statusCopy[objName][inputName] = inputValue;
        this.setState(statusCopy);
    }
    handleChangeCombo2 = (inputName, selectedItem, objName) => {

        let inputValue = selectedItem ? selectedItem : null;
        let statusCopy = Object.assign({}, this.state);
        statusCopy[objName][inputName] = inputValue;
        this.setState(statusCopy);
        if (inputName == 'module') {

            this.getEntityFiltered();
        }
    }

    handleChangeCombo = (inputName, selectedItem, objName) => {

        let inputValue = selectedItem ? selectedItem.id : null;
        let statusCopy = Object.assign({}, this.state);
        statusCopy[objName][inputName] = inputValue;
        this.setState(statusCopy);
    }

    /*************Form Ricerca********************/
    toggleSearchForm(e) {
        e.preventDefault();
        this.setState(oldState => ({ isOpenSearchForm: !oldState.isOpenSearchForm }));
    }

    handleChangeSearch = (el) => {
        let inputName = el.target.name;

        let inputValue = el.target.value;

        this.updateState(inputName, inputValue, 'searchModel');
    }

    handleClickSearch = (e) => {
        e.preventDefault();
        this.getActivityLog({ page: 1 });
    }

    handleClickCancelSearch = (e) => {
        e.preventDefault();
        this.toggleSearchForm(e);
        this.setState({
            searchModel: {
                ...searchProp
            },
        }, () => { this.getActivityLog({ page: 1 }); });
    }

    handleChangePaging = (event) => {
        this.getActivityLog(event);
    }




    updateState = (inputName, inputValue, objName) => {
        this.setState(prevState => ({
            [objName]: {
                ...prevState[objName],
                [inputName]: inputValue
            }
        }));
    }


    DetailsForm = (id) => {
        this.setState({
            DetailModalId: id
            , isOpenDetailsModal: true
        });

    }
    closeDetailsForm = () => {

        this.setState({
            isOpenDetailsModal: false
        });
    }
    //MODALE DETTAGLIO
    renderDetailsForm() {
        const modalHeader = {
            title: "Detail",
            iconDescription: 'Close',
            buttonOnClick: () => this.closeDetailsForm()
        };
        const id = this.state.DetailModalId;
        let itemList = this.state.itemList || [];
        const Details = itemList.find(el => el.id == id);;
        return (
            <ComposedModal
                className="light-modal"
                open={this.state.isOpenDetailsModal}
                danger="false"
                onClose={() => this.closeDetailsForm()}
            >
                <ModalHeader className="margin-modal" {...modalHeader} >
                </ModalHeader>
                <ModalBody className="margin-modal margin-modal-content " >
                    <Form className="bx--grid--full-width">

                        {/* <FormLabel > Lorem ipsum dolor sit lorem a amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.</FormLabel> */}

                        <div className="bx--row">

                            <div className="bx--col-md-6 bx--col-lg-6 ">
                                <FormGroup legendText="Module" >
                                    <TextInput
                                        id="module"
                                        name="module"
                                        value={Details.module != null ? Details.module : ''}
                                        type="text"
                                        labelText=""
                                        className="disable-text"
                                        disabled={true} />
                                </FormGroup>
                            </div>
                            <div className="bx--col-md-6 bx--col-lg-6 ">
                                <FormGroup legendText="Operation" >
                                    <StatusTag value={Details != null ? Details.operation : ''} />
                                    {/* <TextInput
                                    id="operation"
                                    name="operation"
                                    value={Details.operation != null ? Details.operation : ''}
                                    type="text"
                                    labelText=""
                                    className="disable-text"
                                    disabled={true} /> */}
                                </FormGroup>
                            </div>
                            <div className="bx--col-md-6 bx--col-lg-6 ">
                                <FormGroup legendText="Entity">
                                    <TextInput
                                        id="operation"
                                        name="operation"
                                        value={Details.entity != null ? Details.entity : ''}
                                        type="text"
                                        labelText=""
                                        className="bx--text-input  bx--text-input--light disable-text"
                                        disabled={true} />
                                </FormGroup>
                            </div>
                            {Details?.referenceEntity?.toUpperCase() != Details.entityId &&
                                <div className="bx--col-md-6 bx--col-lg-6 ">
                                    <FormGroup legendText="Entity Code">

                                        <TextInput
                                            id="referenceEntity"
                                            name="referenceEntity"
                                            value={Details.referenceEntity != null && Details.referenceEntity != Details.entityId ? Details.referenceEntity : ''}
                                            type="text"
                                            labelText=""
                                            className="bx--text-input  bx--text-input--light disable-text"
                                            disabled={true} />
                                    </FormGroup>
                                </div>
                            }

                            <div className="bx--col-md-6 bx--col-lg-6 ">
                                <FormGroup legendText="Entity Guid">

                                    <TextInput
                                        id="entityId"
                                        name="entityId"
                                        value={Details.entityId != null ? Details.entityId : ''}
                                        type="text"
                                        labelText=""
                                        className="bx--text-input  bx--text-input--light disable-text"
                                        disabled={true} />
                                </FormGroup>
                            </div>

                            {
                                Details.relatedEntityCode != null &&
                                <div className="bx--col-md-6 bx--col-lg-6 ">
                                    <FormGroup legendText="Parent Entity Code" >

                                        <TextInput
                                            id="referenceEntity"
                                            name="referenceEntity"
                                            value={Details.relatedEntityCode != null ? Details.relatedEntityCode : ''}
                                            type="text"
                                            labelText=""
                                            className="bx--text-input  bx--text-input--light disable-text"
                                            disabled={true} />
                                    </FormGroup>
                                </div>
                            }


                            <div className="bx--col-md-6 bx--col-lg-6 ">
                                <FormGroup legendText="Involved field Name" >

                                    <TextInput
                                        id="property"
                                        name="property"
                                        value={Details.property != null ? Details.property : ''}
                                        type="text"
                                        labelText=""
                                        className="bx--text-input  bx--text-input--light disable-text"
                                        disabled={true} />
                                </FormGroup>
                            </div>
                            <div className="bx--col-md-6 bx--col-lg-6 ">
                                <FormGroup legendText="Involved field Value" >

                                    <TextInput
                                        id="value"
                                        name="value"
                                        value={Details.value != null ? Details.value : ''}
                                        type="text"
                                        labelText=""
                                        className="bx--text-input  bx--text-input--light disable-text"
                                        disabled={true} />
                                </FormGroup>

                            </div>
                            <div className="bx--col-md-6 bx--col-lg-6 ">
                                <FormGroup legendText="User" >

                                    <TextInput
                                        id="user"
                                        name="user"
                                        value={Details.user != null ? Details.user : ''}
                                        type="text"
                                        labelText=""
                                        className="bx--text-input  bx--text-input--light disable-text"
                                        disabled={true} />
                                </FormGroup>
                            </div>
                            <div className="bx--col-md-6 bx--col-lg-6 ">
                                <FormGroup legendText="Occurance Date" >

                                    <TextInput
                                        id="user"
                                        name="user"
                                        value={switchDateFormat(Details.occurredAt != null ? Details.occurredAt : '', 'datetime')}
                                        type="text"
                                        labelText=""
                                        className="bx--text-input  bx--text-input--light disable-text"
                                        disabled={true} />
                                </FormGroup>
                            </div>
                        </div>
                    </Form>
                </ModalBody>

            </ComposedModal>);
    }
    //COMPONENTE TENDINA TASTINO

    renderSearchform() {

        const filterItems = {
            module: null,
            operation: null,
            entity: null
        }
        if (this.state.searchModel != null && (this.state.searchModel.occuredAtTo || this.state.searchModel.occuredAtFrom)) {
            var diffduedate =
                (this.state.searchModel.occuredAtTo &&
                    this.state.searchModel.occuredAtFrom) &&
                moment(this.state.searchModel.occuredAtTo).isSameOrAfter(moment(this.state.searchModel.occuredAtFrom), 'day')
        } else {
            var diffduedate = true;
        }

        const validations = {

            start: this.state.searchModel.occurredAtTo ? this.validator.message('Occured At From', this.state.searchModel.occurredAtFrom, 'required') : null,
            end: this.state.searchModel.occurredAtFrom ? this.validator.message('Occured At To', this.state.searchModel.occurredAtTo, 'required') : null,
            endAfterStart: this.validator.message('endAfterStart', this.state.searchModel.occurredAtTo == null || this.state.searchModel.occurredAtFrom == null
                || moment(this.state.searchModel.occurredAtTo).isSameOrAfter(moment(this.state.searchModel.occurredAtFrom), 'day'), 'accepted'),
            //immediateActions: this.validator.message('Immediate Actions', this.state.hocCardModel.immediateActions, 'required'),
            //occurredAtToValid: this.validator.message('Occured At ...', diffduedate, 'accepted'),
        }
        return (
            this.state.isOpenSearchForm &&
            <div>
                <Form autoComplete="off" className="bx--row" onSubmit={this.handleClickSearch}>

                    <FormGroup legendText="" className="bx--col-md-4 bx--col-lg-4">
                        <FormLabel className="some-class">
                            Operation
                                </FormLabel>

                        <ComboBox
                            id="idSearchOpearation"
                            placeholder="All"
                            name="operation"
                            alt="searchModel"
                            onChange={this.handleChangeCombo2}
                            itemToString={item => (item ? item : '')}
                            initialSelectedItem={filterItems.operation}
                            items={this.state.xoperation}
                        //        // items={this.state.search.search}

                        />
                    </FormGroup>

                    <FormGroup legendText="" className="bx--col-md-4 bx--col-lg-4">
                        <FormLabel className="some-class">
                            Module
                                </FormLabel>

                        <ComboBox
                            id="idSearchModule"
                            placeholder="All"
                            name="module"
                            alt="searchModel"
                            onChange={this.handleChangeCombo2}
                            itemToString={item => (item ? item : '')}
                            initialSelectedItem={filterItems.module}
                            items={this.state.xmodule}
                        />
                    </FormGroup>



                    <FormGroup legendText="" className="bx--col-md-4 bx--col-lg-4">
                        <FormLabel className="some-class">
                            Entity
                   </FormLabel>
                        {this.state.isLoadingEntity ? <DropdownSkeleton /> : <ComboBox
                            id="idSearchEntity"
                            placeholder="All"
                            name="entity"
                            alt="searchModel"
                            onChange={this.handleChangeComboEntity}
                            itemToString={item => (item ? item.tableDisplayName : '')}
                            initialSelectedItem={filterItems.entity}
                            items={this.state.xentity}
                        //        // items={this.state.search.search}
                        />}
                    </FormGroup>


                    <FormGroup legendText="" className="bx--col-md-4 bx--col-lg-4">
                        <FormLabel > Entity Code / Guid </FormLabel>
                        <TextInput
                            id="inputsearch"
                            name="referenceEntity"
                            value={this.state.searchModel.referenceEntity}
                            onChange={this.handleChangeSearch}
                            placeholder="Input Entity Name" type="text" labelText="" className="bx--text-input some-class bx--text-input--light" />
                    </FormGroup>


                    <FormGroup legendText="" className="bx--col-md-4 bx--col-lg-4">
                        <FormLabel >Field Name </FormLabel>
                        <TextInput
                            id="inputsearch"
                            name="property"
                            value={this.state.searchModel.property}
                            onChange={this.handleChangeSearch}
                            placeholder="Input Property Name" type="text" labelText="" className="bx--text-input some-class bx--text-input--light" />
                    </FormGroup>

                    <FormGroup legendText="" className="bx--col-md-4 bx--col-lg-4">
                        <FormLabel >Field Value </FormLabel>
                        <TextInput
                            id="inputsearch"
                            name="value"
                            value={this.state.searchModel.value}
                            onChange={this.handleChangeSearch}
                            placeholder="Input Property Value" type="text" labelText="" className="bx--text-input some-class bx--text-input--light" />
                    </FormGroup>

                    <FormGroup legendText="" className="bx--col-md-4 bx--col-lg-4">
                        <FormLabel > User </FormLabel>
                        <TextInput
                            id="inputsearch"
                            name="user"
                            value={this.state.searchModel.user}
                            onChange={this.handleChangeSearch}
                            placeholder="Input Property Value" type="text" labelText="" className="bx--text-input some-class bx--text-input--light" />
                    </FormGroup>


                    <FormGroup legendText="" className="bx--col-md-4 bx--col-lg-4">
                        <FormLabel className="some-class">
                            Date Of Occurrence From
                                    </FormLabel>
                        {this.state.isLoadingDate ? <DatePickerSkeleton /> :


                            <DateTimePicker
                                value={this.state.searchModel.occuredAtFrom}
                                type="date"
                                placeholder={DateFormat}
                                name="occurredAtFrom"
                                alt="searchModel"
                                invalid={validations.start != null}
                                onChange={this.updateState}

                            />
                        }
                        {validations.start && <div className="srv-validation-message">You must enter both dates to filter on the time frame</div>} </FormGroup>
                    <FormGroup legendText="" className="bx--col-md-4 bx--col-lg-4">
                        <FormLabel className="some-class">
                            Date Of Occurrence To
                                        </FormLabel>
                        {this.state.isLoadingDate ? <DatePickerSkeleton /> :


                            <DateTimePicker
                                value={this.state.searchModel.occuredAtTo}
                                type="date"
                                placeholder={DateFormat}
                                name="occurredAtTo"
                                alt="searchModel"
                                onChange={this.updateState}
                                invalid={validations.end != null}
                            />
                        }
                        {validations.end && <div className="srv-validation-message"> You must enter both dates to filter on the time frame  </div>}
                        {validations.endAfterStart && <div className="srv-validation-message">The end date field must be after start date field</div>}
                    </FormGroup>
                </Form>
                <div className="searchFormFooter">
                    <Button className="button--max-width" size="small" kind="secondary" onClick={this.handleClickCancelSearch} >Cancel</Button>
                    <Button className="button--max-width" size="small" onClick={this.handleClickSearch} >Search</Button>
                </div>

            </div>

        );
    }








    /*************Render********************/
    render() {
        this.validator.purgeFields();//si usa quando ci sono validazioni condizionali tra più campi
        const headersDataTable = [
            { key: 'module', header: 'Module' },
            { key: 'operation', header: 'Operation', type: 'status' },
            { key: 'entity', header: 'Entity' },
            { key: 'property', header: 'Field Name' },
            { key: 'occurredAt', header: 'Occurence Date', type: 'datetime' },

        ];

        const paginationProps = () => ({
            page: this.state.currentPage || 1,
            totalItems: this.state.rowCount || 0,
            pageSize: this.state.pageSize || 10,
            pageSizes: [10, 20, 30, 40, 50],
            onChange: this.handleChangePaging,
        });



        const skeletonRowCount = (this.state.rowCount > 0 && this.state.pageSize > this.state.rowCount) ? this.state.rowCount : 5;



        return (
            <AppContext.Consumer>{
                ({ user }) =>
                    <>

                        <PageBreadCrumb
                            linkTo={'/backoffice'}
                            linkText={'BackOffice'}
                            titleLeft={'Activity Log'}
                        />
                        <div className="mainContainer">
                            {/* <Loading active={ } withOverlay={true}  /> */}
                            {this.state.isOpenDetailsModal ? this.renderDetailsForm() : ''}

                            <TableToolbar >
                                <Online>
                                <Search
                                    readOnly
                                    light
                                    className="search cursor-pointer hiddenSearch"
                                    labelText="Search"
                                    placeHolderText="Search"
                                    id="search-1"
                                    onClick={this.toggleSearchForm}
                                />
                                <Button
                                    onClick={this.toggleSearchForm}
                                    className="buttonPaddingIcon"
                                    renderIcon={Data16}
                                    iconDescription="Filter"
                                /></Online>
                            </TableToolbar>


                            {this.renderSearchform()}

                            <DataTable
                                rows={this.state.itemList || []}
                                headers={headersDataTable}
                                useZebraStyles={true}
                                size="compact"
                                render={({ rows, headers, getHeaderProps, getRowProps, getTableProps, getSelectionProps, selectedRows, getBatchActionProps }) => (

                                    <TableContainer className="bx--grid--full-width" title=""  >

                                        {this.state.isLoading ?
                                            <DataTableSkeleton headers={[]} rowCount={skeletonRowCount} zebra={false} compact={false} />
                                            :
                                            <Table>
                                                <TableHead>
                                                    <TableRow>

                                                        {headers.map(header => (
                                                            <TableHeader className={header.type == "bool" ? "align-center" : ""} {...getHeaderProps({ header })} >
                                                                {header.header}
                                                            </TableHeader>
                                                        ))}
                                                        <TableHeader className="align-center">Actions</TableHeader>
                                                    </TableRow>

                                                </TableHead>
                                                <TableBody>
                                                    {
                                                        (rows == null || rows.length == 0)
                                                            ?
                                                            <NoRecordsPlaceholder colSpan={headers.length} />
                                                            :
                                                            rows.map((row) => (
                                                                <TableRow {...getRowProps({ row })}>
                                                                    {
                                                                        row.cells.map(cell =>
                                                                            <RenderDataTableCell key={cell.id} cell={cell} header={headers.find(x => x.key === cell.info.header)} />
                                                                        )}
                                                                    <TableCell key={'action-' + row.id} className="tableActions align-center">
                                                                        <div>
                                                                            <Button onClick={() => this.DetailsForm(row.id)} size="small" renderIcon={Document16} iconDescription="Edit" kind="ghost" />
                                                                        </div>
                                                                    </TableCell>

                                                                </TableRow>
                                                            ))}
                                                </TableBody>
                                            </Table>
                                        }
                                    </TableContainer>
                                )}
                            />

                            <div className="footer-pagination">
                                <Pagination {...paginationProps()} />
                            </div>

                        </div>
                    </>
            }
            </AppContext.Consumer>)

    }
}
